export default __webpack_public_path__ + "media/color/wings-a66b697a.svg";